import http from "plugins/axios";

export default {
  getOrderList({ page, size, coin,startTime,endTime ,  userId }) {
    return http.get({
      url: `/la/admin/finance/trade/list?page=${page}&size=${size}&coin=${coin}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
    });
  },
  exportExcel({  coin, userId,startTime,endTime , }){
    return http.get({
        url: `/la/admin/finance/trade/list/excel?coin=${coin}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
        responseType:'blob',
    })
  },
  getFbsPairs(){
    return http.get({
      url:'admin/symbol/fbsNames' //更改后的路径
      // url:' /la/admin/pair/list'
    })
   },
   getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  },
};
